/**
 * scoreTiers.ts — the Opportunity Score tier words (single source of truth).
 *
 * Extracted from ScorePanel so non-component consumers (the advisor's CONTEXT assembly) can
 * derive the same tier word without importing the panel component — which keeps the score
 * language identical everywhere (the panel headline, the ranked list, and the advisor) with no
 * drift, and no coupling to a heavy component module. ScorePanel re-exports `getTierWord` from
 * here so existing importers are unaffected.
 *
 * UI-SPEC §Score display contract — the words mirror the scoreColor thresholds (D-12):
 * Prime Opportunity ≥70, Strong ≥60, Moderate ≥45, Marginal ≥35, Unfavorable below 35.
 */
export const TIER_WORDS: { threshold: number; word: string }[] = [
  { threshold: 70, word: 'Prime Opportunity' },
  { threshold: 60, word: 'Strong' },
  { threshold: 45, word: 'Moderate' },
  { threshold: 35, word: 'Marginal' },
  { threshold: 0, word: 'Unfavorable' },
]

/** The tier word for an Opportunity Score, using the live-app thresholds above. */
export function getTierWord(score: number): string {
  for (const { threshold, word } of TIER_WORDS) {
    if (score >= threshold) return word
  }
  return 'Unfavorable'
}
